{
  "LOGIN": {
    "TITLE": "Увійти до контакт-центру",
    "EMAIL": {
      "LABEL": "Email",
      "PLACEHOLDER": "example{'@'}companyname.com",
      "ERROR": "Будь ласка, введіть коректну адресу електронної пошти"
    },
    "PASSWORD": {
      "LABEL": "Пароль",
      "PLACEHOLDER": "Пароль"
    },
    "API": {
      "SUCCESS_MESSAGE": "Вхід успішний",
      "ERROR_MESSAGE": "Не вдалося підключитися до Woot сервера. Будь ласка, спробуйте ще раз.",
      "UNAUTH": "Неправильне ім'я користувача / пароль. Будь ласка, спробуйте ще раз.",
      "ACCOUNT_DEACTIVATED": "Ваш обліковий запис було деактивовано. Будь ласка, зверніться до адміністратора.",
      "PASSWORD_LOGIN_DISABLED": "Вхід за паролем вимкнено для вашого облікового запису. Будь ласка, увійдіть за допомогою OAuth (наприклад, Google)."
    },
    "OAUTH": {
      "GOOGLE_LOGIN": "Увійти через Google",
      "BUSINESS_ACCOUNTS_ONLY": "Будь ласка, використовуйте робочу адресу електронної пошти для входу",
      "NO_ACCOUNT_FOUND": "Ми не змогли знайти аккаунт для вашої адреси електронної пошти."
    },
    "FORGOT_PASSWORD": "Забули пароль?",
    "CREATE_NEW_ACCOUNT": "Створити новий обліковий запис",
    "SUBMIT": "Увійти"
  }
}
